"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userValidationService = void 0;
var UserValidationService_1 = require("./implementation/UserValidationService");
exports.userValidationService = new UserValidationService_1.UserValidationService();
//# sourceMappingURL=index.js.map